import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
    document.title = "Shop by Category · Dealswagon";
  }, []);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="categories-page">
      <h1 className="font-heading text-3xl sm:text-4xl text-brand-navy">All Categories</h1>
      <p className="text-slate-600 mt-1">From tools to toys, appliances to apparel — explore every corner of the warehouse.</p>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {cats.map((c) => (
          <Link key={c.id} to={`/shop?category=${c.slug}`} data-testid={`categories-page-${c.slug}`}
            className="group relative rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm hover:shadow-xl hover:-translate-y-1 transition aspect-[4/3]">
            <img src={c.image} alt={c.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/95 via-brand-navy/40 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-4">
              <div className="text-white font-heading text-lg">{c.name}</div>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
